export default "/images/a86fb4feeed9a78d8e8a10f361e822d5.avif";